import LockSolid from '@simplywallst/ui-core/icons/LockSolid';

export const RestrictedTab = ({ title }: { title: string }) => (
  <div className="grid grid-cols-[auto_auto] items-center">
    <LockSolid aria-label="Blocked content" className="fill-attention-strong" />
    {title}
  </div>
);
